// window.Packs.shared.Backbone
export { Backbone } from 'backbone/shared/shared.js';

import GoogleAnalyticsTracker from 'utils/shared/google_analytics_tracker.js';
import ImageUtils from 'utils/shared/image_utils.js';
import Url from 'utils/shared/url.js';

const Utils = {
  GoogleAnalyticsTracker,
  ImageUtils,
  Url
}

export { Utils };



// WEBPACK FOOTER //
// ./app/javascript/packs/shared.js